import * as React from 'react';

import { ContextService } from 'src/core/services/context.service';
import { CardController } from 'src/app/shared/card.controller';
import { ContactPartController } from 'src/app/crm/contacts/parts/contact-part.controller';

interface Props extends ComponentViewProps<ContactItem[]> {
	parentModel: TransportCompanyOfficeItem;
	contextService: ContextService;
	mode: ControlMode;
}

export const OfficeContactPart = (props: Readonly<Props>) => {
	const { model, parentModel, mode, contextService, setBusy } = props;
	if (model == null) {
		return null;
	}

	return (
		<CardController
			title="Contact Information"
			icon="fa fa-address-book-o"
			className="card-borderless"
			mode={mode}>
			<ContactPartController
				model={model}
				parentModel={parentModel}
				mode={mode}
				setBusy={setBusy}
				contextService={contextService}
			/>
		</CardController>
	);
};



// WEBPACK FOOTER //
// ./src/app/products/office/parts/officecontact-part.tsx